import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface RoofingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Roofing: React.FC<RoofingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [roofing, set_roofing] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Roofing']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Roofing': [b.values?.['Exterior Structure']?.['Roofing']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Roofing';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(roofing)}
                />
            ) : (
                <MoneyBox
                    id={'roofing'}
                    allowNegative={false}
                    value={roofing}
                    onChange={(value) => set_roofing(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
